import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
    `sph-button relative inline-flex items-center justify-center gap-2.5 whitespace-nowrap text-foreground [--sph-button-color:var(--color-foreground)] font-semibold leading-none shadow-sm transition-[color,background-color,border-color,box-shadow] duration-[250ms] ease-in-out disabled:pointer-events-none disabled:opacity-50 [&_.sph-icon]:pointer-events-none select-none shrink-0 [&_.item>.sph-icon]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/30 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive`,
    {
        variants: {
            variant: {
                default:
                    'border bg-button text-button-foreground [--sph-button-color:var(--color-button-foreground)] border-button-border [&[data-state=open],&.active,&:hover]:text-accent-dark [&[data-state=open],&.active,&:hover]:border-accent/40 aria-pressed:bg-accent! aria-pressed:text-accent-foreground! aria-pressed:border-accent! aria-pressed:shadow-none',
                primary:
                    'bg-primary text-primary-foreground [--sph-button-color:var(--color-primary-foreground)] hover:bg-primary/80',
                destructive:
                    'bg-button text-destructive [--sph-button-color:var(--color-destructive)] border border-destructive hover:bg-destructive hover:text-white focus-visible:border-destructive focus-visible:ring-destructive/30',
                ghost: 'bg-transparent border border-transparent shadow-none [&.active,&:hover]:border-primary duration-[350ms]',
                transparent: 'border-0 bg-transparent shadow-none focus-visible:ring-[1px]',
            },

            size: {
                sm: 'h-(--button-height-sm) text-sm gap-1.5 px-2 [&.has-icon]:px-1.5',
                md: 'h-(--button-height-md) text-sm gap-1.5 px-3 py-1 [&.has-icon]:px-2.5',
                lg: 'h-(--button-height-lg) text-base px-4 py-2 [&.has-icon]:px-3',
                'icon-sm': 'size-(--button-height-sm)',
                'icon-md': 'size-(--button-height-md)',
                'icon-lg': 'size-(--button-height-lg)',
            },

            circle: {
                false: 'rounded-md',
                true: 'rounded-full',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'lg',
            circle: false,
        },
    },
);
export type ButtonVariants = VariantProps<typeof buttonVariants>;
